import { render, staticRenderFns } from "./email-sent-page.vue?vue&type=template&id=23a1df68&scoped=true"
import script from "./email-sent-page.vue?vue&type=script&lang=ts"
export * from "./email-sent-page.vue?vue&type=script&lang=ts"
import style0 from "./email-sent-page.vue?vue&type=style&index=0&id=23a1df68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a1df68",
  null
  
)

export default component.exports